import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faChevronRight, faSave, faTimes } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "react-tabs/style/react-tabs.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { PopupMessage } from "../../utils/utils";
import "bootstrap";
import LeaseDetails from "../../viewLease/LeaseDetails";
import { hasAccess, getUserType } from "../../utils/index";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class SubmitLease extends React.Component {
  state = {
    redirect: false,
    leaseStatus: "",
    initialValues: {},
    leaseCreationDate: "",
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    leaseId: "",
    unit: [],
    occupierBrand: [],
    occupier: [],
    leaseTermDetails: [],
    renewalTerms: [],
    lockIn: [],
    lockInOccupier: [],
    rentalDetails: [],
    camDetails: [],
    utilities: [],
    mfDetails: [],
    pTaxDetails: [],
    parkingStorageSignage: [],
    rentDepositDetails: [],
    camDepositDetails: [],
    otherDepositDetails: [],
    uploadedDocs: [],
    commercialClauses: [],
    otherClauses: [],
    universalKey: "",
    currentSelection: "Parties, Landlord & Unit Details",
    reviewedOptions: [],
    reviewedCheck: false,
    leaseMenus: [],
    history: [],
    nextSelection: "Parties, Landlord & Unit Details",
    counter: Math.round(),
  };

  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  componentDidMount() {

    let athis = this;
    axios({
      method: "get",
      url: `${apiUrl.apiUrl.url}/create-lease/get-lease-status?leaseId=`+this.props.match.params.id,
    }).then(function(response) {
      let data = response.data;
      athis.setState({
        leaseStatus: data.data.status,
      });
    });
    // fetch(
    //   `${apiUrl.apiUrl.url}/create-lease/get-lease-status?leaseId=` +
    //     this.props.match.params.id
    // )
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {
    //     this.setState({
    //       leaseStatus: data.data.status,
    //     });
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });

    fetch(
      `${apiUrl.apiUrl.url}/lease-view/fetch-lease-menus?leaseId=` +
        this.props.match.params.id,
        {headers}
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          leaseMenus: data.data,
          history: data.history,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  leaseChecked = (val) => {
    this.setState({ currentSelection: val });
  };

  checkedLease = () => {
    const index = this.state.reviewedOptions.indexOf(
      this.state.currentSelection
    );

    if (index != -1) {
      this.state.reviewedOptions.splice(index, 1);
    } else {
      this.state.reviewedOptions.push(this.state.currentSelection);
    }

    console.log(this.state.reviewedOptions, "this.state.reviewedOptions");

    var nextindex = this.state.leaseMenus.indexOf(this.state.currentSelection);
    if (nextindex >= 0 && nextindex < this.state.leaseMenus.length - 1) {
      var nextItem = this.state.leaseMenus[nextindex + 1];
      //this.setState({ nextSelection: nextItem,  counter: Math.round() });

      var that = this;
      setTimeout(() => {
        that.setState(
          {
            nextSelection: nextItem,
          },
          () => {
            //console.log("new callback", this.state.nextSelection);
            //this.setState({ counter: Math.round() });
          }
        );

        console.log("new val", that.state.nextSelection);

        that.state.nextSelection = nextItem;
      }, 1000);
    }

    this.setState({});
  };

  submitForApproval = () => {
    var values = {};
    this.state.leaseStatus = 2;
    values.leaseStatus = this.state.leaseStatus;
    values.leaseSummaryReviewed = 1;
    var self = this;
    axios({
      method: "post",
      url:
        `${apiUrl.apiUrl.url}/create-lease/update-lease-status?lease_id=` +
        this.props.match.params.id,
      data: values,
    }).then(function (response) {
      if (!response.data.success) {
      } else {
        // alert("Data Saved Successfully");
        self.setState({ messsagePopup: true });
      }
    });
  };

  submitForReject = () => {
    this.state.leaseStatus = 0;
    var values = {};
    values.leaseStatus = this.state.leaseStatus;
    values.leaseSummaryReviewed = 1;
    var self = this;
    axios({
      method: "post",
      url:
        `${apiUrl.apiUrl.url}/create-lease/update-lease-status?lease_id=` +
        this.props.match.params.id,
      data: values,
    }).then(function (response) {
      if (!response.data.success) {
      } else {
        // alert("Data Saved Successfully");
        self.setState({ messsagePopup: true });
      }
    });
  };
  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false });
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to={"/createlease"} />;
    }
    return (
      <div
        className="parentContainer"
        
      >
        <div>
          <div>
          <div className="absoluteItemForTopBar">
  <div className="new_breadcrumbs_design">
    <ul className="d-flex align-items-center gap-3 p-0 m-0">
      <li>Create Lease</li>
      <li><FontAwesomeIcon icon={faChevronRight} /></li>
      <li>Submit Lease</li>
      <li><FontAwesomeIcon icon={faChevronRight} /></li>
      <li>
        <a href="#">Submit Lease</a>
      </li>
    </ul>
  </div>
</div>


            <Formik
              initialValues={this.state.initialValues}
              enableReinitialize
              onSubmit={(values, actions) => {
                this.state.leaseStatus = 1;
                values.leaseStatus = this.state.leaseStatus;
                values.leaseSummaryReviewed = 1;
                console.log(values);
                var self = this;
                axios({
                  method: "post",
                  url:
                    `${apiUrl.apiUrl.url}/create-lease/update-lease-status?lease_id=` +
                    this.props.match.params.id,
                  data: values,
                }).then(function (response) {
                  if (!response.data.success) {
                    actions.setSubmitting(false);
                    actions.setErrors(response.data);
                  } else {
                    // alert("Data Saved Successfully");
                    self.setState({ messsagePopup: true });
                  }
                });
              }}
            >
              {({
                values,

                errors,

                touched,

                handleChange,

                handleBlur,

                handleSubmit,

                isSubmitting,
              }) => (
                <Form autoComplete="off" className="customTabs">
                  <LeaseDetails
                    key={this.state.counter}
                    leaseId={this.props.match.params.id}
                    leaseChecked={this.leaseChecked}
                    leaseMenus={this.state.leaseMenus}
                    history={this.state.history}
                    selectedOption={this.state.nextSelection}
                  />

                  {this.state.leaseStatus == 0 && (
                    <div className="container" style={{ float: "left" }}>
                      <div className="row">
                        <div className="row checkBox mb-4">
                          <div className="col-lg-12">
                            <div className="inputContainer col-lg-12 col-md-12 text-center">
                              <div className="row">
                                <label>
                                  <Field
                                    type="checkbox"
                                    name="leaseReviewed"
                                    value="leaseReviewed"
                                    checked={
                                      this.state.reviewedOptions.indexOf(
                                        this.state.currentSelection
                                      ) != -1
                                    }
                                    className="sameAs"
                                    onClick={(e) => {
                                      this.checkedLease(e);
                                    }}
                                  />
                                  Checked
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="unitFormContainer mt-0">
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-12 text-center">
                          <div
                            className="btnContainer submitLeaseBtnContainer formSubmit mt-0"
                            style={{ paddingRight: "0" }}
                          >
                            {this.state.reviewedOptions.length == "19" && (
                              <div
                                style={{
                                  float: "none",
                                  display: "inline-block",
                                }}
                              >
                                {this.state.leaseStatus == 0 && (
                                  <button type="submit">
                                    <FontAwesomeIcon icon={faSave} /> Submit
                                    Lease
                                  </button>
                                )}
                              </div>
                            )}

                            {hasAccess(["admin", "checker"]) &&
                              this.state.leaseStatus == 1 && ( //|| this.state.leaseStatus == 2
                                <div>
                                  <button
                                    type="button"
                                    className="approve"
                                    onClick={(e) => {
                                      //this.state.leaseStatus = 2;
                                      this.submitForApproval();
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faCheck} /> Approve
                                  </button>
                                  <button
                                    type="button"
                                    className="reject"
                                    onClick={(e) => {
                                      //this.state.leaseStatus = 2;
                                      this.submitForReject();
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faTimes} /> Reject
                                  </button>
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="container-fluid utilities"
                    style={{ float: "left" }}
                  >
                    <div className="row">
                      <div className="tableContainer">
                        <table className="table tableSimple">
                          <thead>
                            <tr>
                              <th scope="col">User Name</th>
                              <th scope="col">Role</th>
                              <th scope="col" colSpan="">
                                Action
                              </th>
                              <th scope="col">TimeStamp</th>
                            </tr>
                          </thead>
                        </table>
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
            <PopupMessage
              open={this.state.messsagePopup}
              content={this.state.popupContent}
              redirectAfterSave={this.redirectAfterSave}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SubmitLease);
